import type { ShareBlocks } from '@common/types/site.type';
import type { SiteContentEntity } from '@common/types/site-content.type';
import type { ContentState } from './content.reducer';
import { WEBSITE_CONTENT_FEATURE_KEY } from './content.reducer';
import type { WebsiteState } from '../website-feature.reducer';
import type { UnmigratedBlock } from '@web/store/page-structure/page-structure/unmigrated-blocks';

import { createSelector } from '@ngrx/store';
import { websiteState } from '../website-state.selectors';

export const selectContentState = createSelector(
    websiteState,
    (state: WebsiteState): ContentState => state[WEBSITE_CONTENT_FEATURE_KEY]
);

export const selectSiteContent = createSelector(
    selectContentState,
    (state: ContentState): SiteContentEntity => state?.site
);
export const selectPageContent = createSelector(
    selectContentState,
    (state: ContentState): SiteContentEntity => state?.page
);

export const selectSiteSharedBlocks = createSelector(
    selectSiteContent,
    (contents: SiteContentEntity): ShareBlocks => contents?.draft_shared_blocks ?? contents?.shared_blocks
);
export const selectIsDirty = createSelector(selectContentState, (state: ContentState): boolean => state?.isDirty);
export const selectIsLoading = createSelector(selectContentState, (state: ContentState): boolean => state?.isLoading);
export const selectDirtyPageId = createSelector(
    selectContentState,
    (state: ContentState): string | null => state?.dirtyPageId
);

export const selectPageContentStructureUpdatedAt = createSelector(
    selectPageContent,
    (content: SiteContentEntity): string | null => content?.structure_updated_at
);

export const selectIsReset = createSelector(selectContentState, (state: ContentState): boolean => state?.isReset);

export const selectPageVersions = createSelector(
    selectContentState,
    (state: ContentState): Record<string, string> => state?.pageVersions ?? {}
);

export const selectUnmigratedBlocks = createSelector(
    selectContentState,
    (state: ContentState): UnmigratedBlock[] => state?.unmigratedBlocks ?? []
);

export const selectStaleVersionPageIds = createSelector(
    selectContentState,
    (state: ContentState): string[] => state?.staleVersionPageIds ?? []
);

export const selectDeletedPageIds = createSelector(
    selectContentState,
    (state: ContentState): string[] => state?.deletedPageIds ?? []
);

export const selectIsAutoSavePaused = createSelector(selectContentState, (state: ContentState): boolean =>
    Boolean(state?.isAutoSavePaused)
);
